module.exports = __webpack_public_path__ + "img/logo.f06daccf.png";